import {InteractionRequiredAuthError} from '@azure/msal-browser';

import type {PublicClientApplication, SilentRequest} from '@azure/msal-browser';
import type {BeforeRequestState} from 'ky';

export function createAttachToken(
  msal: PublicClientApplication,
  mainRequest: SilentRequest
) {
  return async function attachToken({request}: BeforeRequestState): Promise<void> {
    // msal.initialize() is idempotent and resolves immediately once already
    // initialized, so this just guards against acquireTokenSilent firing
    // before the instance's async init has completed (e.g. admin's
    // MsalProvider-driven init, or any request that outraces the app's
    // bootstrap gate).
    await msal.initialize();
    const knownAuthority = msal.getConfiguration().auth.knownAuthorities?.[0];
    const account =
      msal.getActiveAccount() ??
      msal.getAllAccounts().find((a) => !knownAuthority || a.environment === knownAuthority);
    try {
      const {accessToken} = await msal.acquireTokenSilent({
        ...mainRequest,
        account: account ?? undefined,
      });
      request.headers.set('Authorization', `Bearer ${accessToken}`);
    } catch (error) {
      if (
        error instanceof InteractionRequiredAuthError ||
        (error as {errorCode?: string}).errorCode === 'no_account_error' ||
        (error as {errorCode?: string}).errorCode === 'authority_mismatch'
      ) {
        void msal.loginRedirect(mainRequest);
        return;
      }
      throw error;
    }
  };
}
